import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../store/auth';
import { useT } from '../lib/i18n';

export function AuthGate() {
  const { session, loading } = useAuth();
  const t = useT();

  if (loading) {
    return (
      <div className="min-h-[100dvh] grid place-items-center bg-navy-900 text-gold-500 wordmark">
        {t('auth.gate.loading')}
      </div>
    );
  }

  if (!session) return <Navigate to="/sign-in" replace />;
  return <Outlet />;
}
